// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var Form = {};

var Field = {};

function createSubmitHandler(onSubmit) {
  return React.useCallback((function (values) {
                if (onSubmit !== undefined) {
                  return onSubmit(values);
                }
                
              }), [onSubmit]);
}

function useFormStateHandler(onFormChange, onValidationChange, onPristineChange, formProps) {
  React.useEffect((function () {
          onFormChange(formProps.values);
          onValidationChange(formProps.valid);
          if (onPristineChange !== undefined) {
            onPristineChange(formProps.pristine);
          }
          
        }), [
        formProps.values,
        formProps.valid,
        formProps.pristine
      ]);
}

export {
  Form ,
  Field ,
  createSubmitHandler ,
  useFormStateHandler ,
}
/* react Not a pure module */
